function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { ConsentCookieName } from "./consts";
import { load as getCookie } from "isomorphic-cookie";
import { whenReady } from "./hooks";
export var makeChainedFunction = function(obj, method, fn) {
    if (typeof obj !== "object" || obj === null) {
        throw new Error("obj must be an object but got " + obj);
    }
    if (typeof method !== "string") {
        throw new Error("method must be a string");
    }
    if (typeof obj[method] !== "function" && typeof obj[method] !== "undefined") {
        throw new Error("Method " + method + " is not a function");
    }
    var current = obj[method] || function() {};
    var chain = function chain() {
        current.apply(this, arguments);
        fn.apply(this, arguments);
    };
    // Make it is assigned to, it adds it to the chain instead
    Object.defineProperty(obj, method, {
        get: function() {
            return chain;
        },
        set: function(value) {
            if (typeof value !== "function") {
                return;
            }
            var prev = current;
            current = function current() {
                prev.apply(this, arguments);
                value.apply(this, arguments);
            };
        },
        // Allow the property to be deleted or redefined
        configurable: true
    });
    return chain;
};
/**
 * @param {string} paramsString
 * @returns {string[]}
 *
 * @example
 * const paramsString = "isGpcEnabled=0&datestamp=2023-12-27T23%3A14%3A38.211Z&version=202311.1.0&browserGpcFlag=0&isIABGlobal=false&hosts=&consentId=xxxx968&interactionCount=0&landingPath=NotLandingPage&groups=TAB01%3A1%2CC0004%3A1%2CC0001%3A0%2CC0003%3A1%2CC0002%3A1%2CTAB02%3A1&AwaitingReconsent=false";
 * const groups = extractConsentGroups(paramsString);
 * console.log(groups); // ["TAB01", "C0004", "C0003", "C0002", "TAB02"]
 */ export function extractConsentGroups(paramsString) {
    var params = new URLSearchParams(paramsString);
    var groupsParam = params.get("groups");
    if (groupsParam) {
        return groupsParam.split(",")// If it doesn't end with :1, the user didn't consent to it
        .filter(function(group) {
            return group.endsWith(":1");
        })// Remove the :1 from the end of the group name
        .map(function(group) {
            return group.replace(":1", "");
        });
    }
    return [];
}
/**
 * @returns {string[]}
 */ export function getCookieConsentGroups() {
    var consentCookie = getCookie(ConsentCookieName);
    return extractConsentGroups(consentCookie);
}
export function getConsentGroups() {
    return _getConsentGroups.apply(this, arguments);
}
function _getConsentGroups() {
    _getConsentGroups = _async_to_generator(function() {
        var _window_OnetrustActiveGroups, _window, regex, _window_OnetrustActiveGroups1, cookieGroups;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    regex = /[^,]/;
                    // return imediately when window.OnetrustActiveGroups exists and has values;
                    if (typeof window !== "undefined" && window.OnetrustActiveGroups && regex.test(window.OnetrustActiveGroups)) {
                        ;
                        return [
                            2,
                            (_window_OnetrustActiveGroups1 = window.OnetrustActiveGroups) == null ? void 0 : _window_OnetrustActiveGroups1.split(",")
                        ];
                    }
                    // make sure onetrust is ready to be read
                    return [
                        4,
                        whenReady()
                    ];
                case 1:
                    _state.sent();
                    cookieGroups = getCookieConsentGroups();
                    if (cookieGroups.length) {
                        return [
                            2,
                            cookieGroups
                        ];
                    }
                    // make sure return an array-like
                    return [
                        2,
                        ((_window = window) == null ? void 0 : (_window_OnetrustActiveGroups = _window.OnetrustActiveGroups) == null ? void 0 : _window_OnetrustActiveGroups.split(",")) || []
                    ];
            }
        });
    });
    return _getConsentGroups.apply(this, arguments);
}
